import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";

import NumberSlider from "/src/components/common/Form/NumberSlider";

import { BASEMAPS, BASEMAPS_ENTRIES, LEAFLET_LAYER_ICON } from "./basemaps.js";

const MapSelector = ({ visible, setVisible, mapLayers, setMapLayers }) => {

  const renderHeader = () => {
    return (
      <Modal.Header closeButton>
        <Modal.Title className="d-flex flex-row align-items-center fw-bold h6 gap-2">
          <img src={LEAFLET_LAYER_ICON} width={25} height={25} />
          <div>Layers</div>
        </Modal.Title>
      </Modal.Header>
    );
  }

  const toggleMapLayer = (id) => {
    let newMapLayers = [...mapLayers];
    const layer = newMapLayers.find(item => item.id === id);
    layer.visible = !layer.visible;
    setMapLayers(newMapLayers);
  }

  const setMapLayerOpacity = (id, opacity) => {
    let newMapLayers = [...mapLayers];
    const layer = newMapLayers.find(item => item.id === id);
    layer.opacity = (opacity / 100);
    setMapLayers(newMapLayers);
  }

  const renderControl = (item) => {
    return (
      <div key={item.id} className="d-flex flex-column p-2 bg-light rounded-4">
        <div className="d-flex flex-row align-items-start mx-2">
          {/*<Button className="ps-0" variant="link"><ArrowUpIcon /></Button>*/}
          <div className="d-flex flex-column flex-fill gap-2">
            <div className="d-flex flex-row align-items-center justify-content-between">
              <div className="d-flex flex-row align-items-center gap-2">
                <img src={item.icon} width={25} height={25} style={{ objectFit: "contain" }}/>
                <Form.Label className="m-0 fw-bold h6">{item.name}</Form.Label>
              </div>
              <Form.Check type="switch" checked={item.visible} onChange={() => toggleMapLayer(item.id)}/>
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center gap-3 me-2">
              <Form.Label className="m-0 small text-muted">Opacity</Form.Label>
              <NumberSlider value={item.visible ? item.opacity*100 : 0} min={0} max={100} step={1} onChange={e => item.visible ? setMapLayerOpacity(item.id, e) : null} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderBody = () => {
    return (
      <Modal.Body className="d-flex flex-column gap-1">
        {mapLayers.map(item => renderControl(item))}
      </Modal.Body>
    );
  }

  const renderFooter = () => {

  }

  return (
    <Modal show={visible} onHide={() => setVisible(false)} animation={false} backdrop="static">
      {renderHeader()}
      {renderBody()}
      {renderFooter()}
    </Modal>
  );

}

export default MapSelector;
